<template>
  <div class="scorebook">
    <Head :index="'9'"></Head>
    <div class="catalogue">
      <div class="booktitle" v-if="shareBookList.length > 0">谱书预览</div>
      <div
        v-for="(item, index) in shareBookList"
        :key="index"
        @click="viewpdf(item)"
        class="el-collapse-item__header"
      >
        <span
          style="
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            display: block;
          "
          :title="item.name"
          >{{ item.name }}</span
        >
      </div>

      <el-collapse accordion @change="handleChange">
        <div
          class="booktitle"
          style="margin-top: 20px"
          v-if="mySelfBookList.length > 0"
        >
          谱书编辑
        </div>
        <el-collapse-item
          v-for="(item, index) in mySelfBookList"
          :key="index"
          :name="item.id"
        >
          <template slot="title">
            <span
              style="
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              "
              :title="item.name"
              >{{ item.name }}</span
            >
          </template>
          <div style="text-align: right">
            <span
              style="color: blue; cursor: pointer"
              @click.stop="bookEdit(item)"
              >[编辑谱书]</span
            >
            &nbsp;&nbsp;
            <span
              style="color: red; cursor: pointer"
              @click.stop="bookDel(item)"
              >[删除谱书]</span
            >
          </div>
          <el-tree
            :data="chapterListData[item.id]"
            :props="treeProps"
            node-key="id"
            @node-click="chapterClick"
            :expand-on-click-node="false"
            default-expand-all
          >
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <table>
                <tr>
                  <td style="width: 180px" @click="view(node, data)">
                    {{ node.label }}
                  </td>
                  <td style="text-align: right">
                    <span v-if="data.type == 10"
                      >[
                      <a style="color: #3a8ee6" @click="addFun(node.data)"
                        >添加</a
                      >
                      ]</span
                    >
                    <span
                      v-if="data.type != 9 && data.type != 10 && data.type != 98"
                      @click="editFun(node.data)"
                      >[ <a style="color: #cf9236">编辑</a> ]</span
                    >
                  </td>
                </tr>
              </table>
            </span>
          </el-tree>
        </el-collapse-item>
      </el-collapse>
      <div @click="addScoreBook('add')" class="liAdd">
        <!-- addDialog = true; dialogType = 'add'; -->
        <i class="el-icon-plus"></i> 添加谱书
      </div>
    </div>
    <!-- <div v-if="type == 100" style="float:left;width: 400px ;margin: 0;margin-left: 29%; min-height:260px;border:0">
       <pdfjs :pdfUrl="pdfUrl" ></pdfjs>
     </div> -->
     <!-- <el-dialog :visible.sync="coverFlag" width="90%" height="100%">
      SADASDASD -->
      <!-- <div v-if="type =='-1' && coverShow!=2" class="contDiv"  :class="{ conMoDiv: flag == 'app' }">
        下一页
        <p class="nextB" :class="{ nextMoB: flag == 'app' }">  <el-button type="primary" @click="nextBtn()" v-show="coverShow==1">下一页</el-button></p>
        封面
        <coverCom :catalog="bookCatalog" :coverData="coverData" v-show="coverShow==1" />
      </div>
     <div v-if="type =='-1' && coverShow==2" class="contMobileDiv">
          主要内容展示
        <div class="conMainDiv" v-show="coverShow==2" >
            <readerMobileCom :readerData="readerData" :chapMap="chapMap" :chapMapIndex="chapMapIndex" :chapterListData="chapterListData" @coverFun="coverFun"/>
          </div> 
      </div> -->
  <!-- </el-dialog> -->
    <div v-if="type == 100" style=" float: left; width: 400px;  margin: 0; margin-left: 29%;  min-height: 260px; border: 0;" >
      <pdfjs :pdfUrl="pdfUrl"></pdfjs>
    </div>
    <div v-if="type != 100" class="centerDiv">
      <div v-if="type == 0" class="psfm">
        <!-- <h1 v-html="title"></h1> -->
        <div class="con address" v-html="content.psdz"></div>
        <div class="con psmc" v-html="content.psmc"></div>
        <div class="con bzr" v-html="content.bzr"></div>
        <div class="con date" v-html="'编纂时间: ' + content.bzsj"></div>
        <div class="con juanhao" v-html="'卷号: ' + content.jh"></div>
      </div>
      <div v-else-if="type == 1">
        <h1 v-html="title"></h1>
        <ul>
          <li v-for="item in content.avator" :key="item.id">
            <img :src="item" />
          </li>
        </ul>
        <div class="con" v-html="content.content"></div>
      </div>
      <div v-else-if="type == 2">
        <h1 v-html="title"></h1>
        <ul>
          <li v-for="item in content.avator" :key="item.id">
            <img :src="item" />
          </li>
        </ul>
        <div class="con" v-html="content.content"></div>
      </div>
      <div v-else-if="type == 3">
        <h1 v-html="title"></h1>
        <p>(名人、先贤、家人论述家谱的重要性)</p>
        <div class="con" v-html="content.content"></div>
      </div>
      <div v-else-if="type == 4">
        <h1 v-html="title"></h1>
        <p>(凡例是编修家谱所遵循的规则)</p>
        <div class="con" v-html="content.content"></div>
      </div>
      <div v-else-if="type == 5">
        <h1 v-html="title"></h1>
        <p>(记录本姓起源、始祖、始迁祖、世派、迁徙源流等)</p>
        <div class="con" v-html="content.content"></div>
      </div>
      <div v-else-if="type == 6">
        <h1 v-html="title"></h1>
        <p>(主要介绍姓氏源流、迁徙经过、郡望堂号、编谱原则、编谱过程等)</p>
        <div class="con" v-html="content.content"></div>
      </div>
      <div v-else-if="type == 7">
        <h1 v-html="title"></h1>
        <p>(教育、规范和约束家族成员的训诫、法规)</p>
        <div class="con" v-html="content.content"></div>
      </div>
      <div v-else-if="type == 17">
        <h1 v-html="title"></h1>
        <p>(教育、规范和约束家族成员的训诫、法规)</p>
        <div class="con" v-html="content.content"></div>
      </div>
      <div v-else-if="type == 8">
        <h1 v-html="title"></h1>
        <p>
          (又称昭穆、字派、行派、排序，即用以表明同祖为宗家族世序血缘秩序的命名字辈序列)
        </p>
        <div class="con">
          <ul>
            <li v-for="(item, index) in content.content" :key="index">
              <p>{{ item.shixu }}世</p>
              <p>{{ item.beifen }}</p>
            </li>
          </ul>
        </div>
      </div>
      <div v-else-if="type == 98">
        <h1 v-html="title"></h1>
        <div class="con" v-html="content"></div>
      </div>
      <!--      <div v-else-if="type == 10">-->
      <!--        <h1 v-html="title"></h1>-->
      <!--        <div class="con" v-html="content.content"></div>-->

      <!--      </div>-->
      <div v-else-if="type == 11">
        <h1 v-html="title"></h1>
        <p>(家族中有重要贡献的人物事迹或族人的著述)</p>
        <div class="con" v-html="content.content"></div>
      </div>
      <div v-else-if="type == 12">
        <h1 v-html="title"></h1>
        <p>(记录家族墓地图、坟向、碑文内容等)</p>
        <div class="con" v-html="content.content"></div>
      </div>
      <div v-else-if="type == 13">
        <h1 v-html="title"></h1>
        <p>(记录家族祭祀和议事场所)</p>
        <div class="con" v-html="content.content"></div>
      </div>
      <div v-else-if="type == 14">
        <h1 v-html="title"></h1>
        <p>(何时、何地、何事、何因、何果、评价)</p>
        <div class="con" v-html="content.content"></div>
      </div>
      <div v-else-if="type == 15">
        <h1 v-html="title"></h1>
        <ul>
          <li v-for="item in content.avator" :key="item.id">
            <img :src="item" />
          </li>
        </ul>
        <div class="con">主编：{{ content.zhubian }}</div>
        <div class="con">副主编：{{ content.fuzhubian }}</div>
        <div class="con">编委：{{ content.bianwei }}</div>
        <div class="con">成员简介：<span v-html="content.cyjj"></span></div>
      </div>
      <div v-else-if="type == 16">
        <h1 v-html="title"></h1>
        <p>(说明家谱编修果,或请假内容对后人的嘱托)</p>
        <div class="con" v-html="content.content"></div>
      </div>
    </div>
    <el-dialog :visible.sync="coverFlag" width="100%" height="100%" class="coverMobile">
        <div v-if="type =='-1' && coverShow!=2" class="contDiv"  :class="{ conMoDiv: flag == 'app' }">
                <!-- 下一页 -->
              <p class="nextB" :class="{ nextMoB: flag == 'app' }">  <el-button type="primary" @click="nextBtn()" v-show="coverShow==1">下一页</el-button></p>
              <!-- 封面 -->
              <coverCom :catalog="bookCatalog" :coverData="coverData" v-show="coverShow==1" />
        </div>
        <div v-if="type =='-1' && coverShow==2" class="contMobileDiv">
              <!-- 主要内容展示 -->
            <div class="conMainDiv" v-show="coverShow==2" >
                <readerMobileCom :readerData="readerData" :chapMap="chapMap" :chapMapIndex="chapMapIndex" :chapterListData="chapterListData" @coverFun="coverFun"/>
              </div> 
        </div>
      </el-dialog>
    <!-- 添加 编辑谱书 -->
    <el-dialog :visible.sync="addDialog" width="90%">
      <el-form ref="form" :model="bookAddData" label-width="80px">
        <el-form-item label="谱书名称">
          <el-input v-model="bookAddData.name"></el-input>
        </el-form-item>
        <!-- <el-form-item label="谱书简介">
            <el-input type="textarea" v-model="bookAddData.intro"></el-input>
        </el-form-item> -->
        <el-form-item label="家族共享" v-if="familyData.canDel == true">
          <el-radio-group v-model="bookAddData.open">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialog = false">取 消</el-button>
        <el-button type="primary" @click="bookSubmit()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 封面 -->
    <el-dialog :visible.sync="psfmDialog" width="90%" height="100%">
      <el-form ref="form" :model="psfmData" label-width="80px">
        <el-form-item label="章节名称">
          <el-input
            placeholder="请输入章节名称"
            v-model="psfmData.name"
          ></el-input>
        </el-form-item>
        <el-form-item label="谱书名称">
          <el-input
            placeholder="请输入谱书名称"
            v-model="psfmData.psmc"
          ></el-input>
        </el-form-item>
        <el-form-item label="图腾照片">
          <div
            class="demo-image__preview avatorSpan"
            v-for="(item, index) in psfmData.avator"
            :key="index"
          >
            <i class="el-icon-close" @click="delavator(psfmData, index)"></i>
            <el-image :src="item"></el-image>
          </div>
          <div class="avator" @click="clickfile">
            <img v-if="psfmData.img || ''" alt="" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </div>
          <input
            type="file"
            name=""
            ref="file"
            accept="image/jpeg,image/jpg,image/png"
            @change="changeImage"
            style="display: none"
          />
        </el-form-item>
        <el-form-item label="谱书地址">
          <el-input
            placeholder="请输入省市区县村"
            v-model="psfmData.psdz"
          ></el-input>
        </el-form-item>
        <el-form-item label="编著人">
          <el-input placeholder="请输入内容" v-model="psfmData.bzr"></el-input>
        </el-form-item>
        <el-form-item label="编著时间">
          <el-input placeholder="请输入内容" v-model="psfmData.bzsj"></el-input>
        </el-form-item>
        <el-form-item label="卷号">
          <el-input placeholder="请输入内容" v-model="psfmData.jh"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="psfmDialog = false">取 消</el-button>
        <el-button type="primary" @click="psfmSubmit()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 祖宗相赞 -->
    <el-dialog :visible.sync="zzxzDialog" width="90%" height="100%">
      <el-form ref="form" :model="zzxzData" label-width="80px">
        <el-form-item label="章节名称">
          <el-input placeholder="请输入内容" v-model="zzxzData.name"></el-input>
        </el-form-item>

        <el-form-item label="照片">
          <div
            class="demo-image__preview avatorSpan"
            v-for="(item, index) in zzxzData.avator"
            :key="index"
          >
            <i class="el-icon-close" @click="delavator(zzxzData, index)"></i>
            <el-image :src="item"></el-image>
          </div>
          <div class="avator" @click="clickfile">
            <img v-if="zzxzData.img || ''" alt="" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </div>
          <input
            type="file"
            name=""
            ref="file"
            accept="image/jpeg,image/jpg,image/png"
            @change="changeImage"
            style="display: none"
          />
        </el-form-item>
        <el-form-item label="像赞内容">
          <!--          <quill-editor-->
          <!--            ref="myQuillEditor"-->
          <!--            v-model="zzxzData.content"-->
          <!--            :options="editorOption"-->
          <!--            @blur="onEditorBlur($event)"-->
          <!--            @focus="onEditorFocus($event)"-->
          <!--            @ready="onEditorReady($event)"-->
          <!--          />-->
          <vue-ueditor-wrap
            v-model="zzxzData.content"
            editor-id="editor1"
            :config="editorConfig"
            :editorDependencies="['ueditor.config.js', 'ueditor.all.js']"
            style="height: 100%"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="zzxzDialog = false">取 消</el-button>
        <el-button type="primary" @click="zzxzSubmit()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 姓氏图腾 -->
    <el-dialog :visible.sync="xsttDialog" width="90%" height="100%">
      <el-form ref="form" :model="xsttData" label-width="80px">
        <el-form-item label="名称">
          <el-input placeholder="请输入内容" v-model="xsttData.name"></el-input>
        </el-form-item>

        <el-form-item label="照片">
          <div
            class="demo-image__preview avatorSpan"
            v-for="(item, index) in xsttData.avator"
            :key="index"
          >
            <i class="el-icon-close" @click="delavator(xsttData, index)"></i>
            <el-image :src="item"></el-image>
          </div>
          <div class="avator" @click="clickfile">
            <img v-if="xsttData.img || ''" alt="" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </div>
          <input
            type="file"
            name=""
            ref="file"
            accept="image/jpeg,image/jpg,image/png"
            @change="changeImage"
            style="display: none"
          />
        </el-form-item>
        <el-form-item label="图腾介绍">
          <!--          <quill-editor-->
          <!--            ref="myQuillEditor"-->
          <!--            v-model="xsttData.content"-->
          <!--            :options="editorOption"-->
          <!--            @blur="onEditorBlur($event)"-->
          <!--            @focus="onEditorFocus($event)"-->
          <!--            @ready="onEditorReady($event)"-->
          <!--          />-->
          <vue-ueditor-wrap
            v-model="xsttData.content"
            editor-id="editor2"
            :config="editorConfig"
            :editorDependencies="['ueditor.config.js', 'ueditor.all.js']"
            style="height: 100%"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="xsttDialog = false">取 消</el-button>
        <el-button type="primary" @click="xsttSubmit()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 谱论题词 -->
    <el-dialog :visible.sync="pltcDialog" width="90%" height="100%">
      <el-form ref="form" :model="pltcData" label-width="80px">
        <el-form-item label="名称">
          <el-input placeholder="请输入内容" v-model="pltcData.name"></el-input>
        </el-form-item>
        <el-form-item label="谱论题词">
          <!--          <quill-editor-->
          <!--            ref="myQuillEditor"-->
          <!--            v-model="pltcData.content"-->
          <!--            :options="editorOption"-->
          <!--            @blur="onEditorBlur($event)"-->
          <!--            @focus="onEditorFocus($event)"-->
          <!--            @ready="onEditorReady($event)"-->
          <!--          />-->
          <vue-ueditor-wrap
            v-model="pltcData.content"
            editor-id="editor3"
            :config="editorConfig"
            :editorDependencies="['ueditor.config.js', 'ueditor.all.js']"
            style="height: 100%"
          />
          \
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="pltcDialog = false">取 消</el-button>
        <el-button type="primary" @click="pltcSubmit()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 凡例 -->
    <el-dialog :visible.sync="flDialog" width="90%" height="100%">
      <el-form ref="form" :model="flData" label-width="80px">
        <el-form-item label="名称">
          <el-input placeholder="请输入内容" v-model="flData.name"></el-input>
        </el-form-item>
        <el-form-item label="凡例">
          <!--          <quill-editor-->
          <!--            ref="myQuillEditor"-->
          <!--            v-model="flData.content"-->
          <!--            :options="editorOption"-->
          <!--            @blur="onEditorBlur($event)"-->
          <!--            @focus="onEditorFocus($event)"-->
          <!--            @ready="onEditorReady($event)"-->
          <!--          />-->
          <vue-ueditor-wrap
            v-model="flData.content"
            editor-id="editor4"
            :config="editorConfig"
            :editorDependencies="['ueditor.config.js', 'ueditor.all.js']"
            style="height: 100%"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="flDialog = false">取 消</el-button>
        <el-button type="primary" @click="flSubmit()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 姓氏源流 -->
    <el-dialog :visible.sync="xsylDialog" width="90%" height="100%">
      <el-form ref="form" :model="xsylData" label-width="80px">
        <el-form-item label="名称">
          <el-input placeholder="请输入内容" v-model="xsylData.name"></el-input>
        </el-form-item>
        <el-form-item label="姓氏源流">
          <!--          <quill-editor-->
          <!--            ref="myQuillEditor"-->
          <!--            v-model="xsylData.content"-->
          <!--            :options="editorOption"-->
          <!--            @blur="onEditorBlur($event)"-->
          <!--            @focus="onEditorFocus($event)"-->
          <!--            @ready="onEditorReady($event)"-->
          <!--          />-->
          <vue-ueditor-wrap
            v-model="xsylData.content"
            editor-id="editor5"
            :config="editorConfig"
            :editorDependencies="['ueditor.config.js', 'ueditor.all.js']"
            style="height: 100%"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="xsylDialog = false">取 消</el-button>
        <el-button type="primary" @click="xsylSubmit()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 家谱序言 -->
    <el-dialog :visible.sync="jpxyDialog" width="90%" height="100%">
      <el-form ref="form" :model="jpxyData" label-width="80px">
        <el-form-item label="名称">
          <el-input placeholder="请输入内容" v-model="jpxyData.name"></el-input>
        </el-form-item>
        <el-form-item label="家谱序言">
          <!--          <quill-editor-->
          <!--            ref="myQuillEditor"-->
          <!--            v-model="jpxyData.content"-->
          <!--            :options="editorOption"-->
          <!--            @blur="onEditorBlur($event)"-->
          <!--            @focus="onEditorFocus($event)"-->
          <!--            @ready="onEditorReady($event)"-->
          <!--          />-->
          <vue-ueditor-wrap
            v-model="jpxyData.content"
            editor-id="editor6"
            :config="editorConfig"
            :editorDependencies="['ueditor.config.js', 'ueditor.all.js']"
            style="height: 100%"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="jpxyDialog = false">取 消</el-button>
        <el-button type="primary" @click="jpxySubmit()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 家规 -->
    <el-dialog :visible.sync="jgDialog" width="90%" height="100%">
      <el-form ref="form" :model="jgData" label-width="80px">
        <el-form-item label="名称">
          <el-input placeholder="请输入内容" v-model="jgData.name"></el-input>
        </el-form-item>
        <el-form-item label="家规">
          <!--          <quill-editor-->
          <!--            ref="myQuillEditor"-->
          <!--            v-model="jgData.content"-->
          <!--            :options="editorOption"-->
          <!--            @blur="onEditorBlur($event)"-->
          <!--            @focus="onEditorFocus($event)"-->
          <!--            @ready="onEditorReady($event)"-->
          <!--          />-->
          <vue-ueditor-wrap
            v-model="jgData.content"
            editor-id="editor7"
            :config="editorConfig"
            :editorDependencies="['ueditor.config.js', 'ueditor.all.js']"
            style="height: 100%"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="jgDialog = false">取 消</el-button>
        <el-button type="primary" @click="jgSubmit()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 家训 -->
    <el-dialog :visible.sync="jxDialog" width="90%" height="100%">
      <el-form ref="form" :model="jxData" label-width="80px">
        <el-form-item label="名称">
          <el-input placeholder="请输入内容" v-model="jxData.name"></el-input>
        </el-form-item>
        <el-form-item label="家规">
          <!--          <quill-editor-->
          <!--            ref="myQuillEditor"-->
          <!--            v-model="jxData.content"-->
          <!--            :options="editorOption"-->
          <!--            @blur="onEditorBlur($event)"-->
          <!--            @focus="onEditorFocus($event)"-->
          <!--            @ready="onEditorReady($event)"-->
          <!--          />-->
          <vue-ueditor-wrap
            v-model="jxData.content"
            editor-id="editor17"
            :config="editorConfig"
            :editorDependencies="['ueditor.config.js', 'ueditor.all.js']"
            style="height: 100%"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="jxDialog = false">取 消</el-button>
        <el-button type="primary" @click="jxSubmit()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 姓氏源流 -->
    <el-dialog :visible.sync="zbpDialog" width="90%" height="100%">
      <el-form ref="form" :model="zbpData" label-width="80px">
        <el-form-item label="名称">
          <el-input placeholder="请输入内容" v-model="zbpData.name"></el-input>
        </el-form-item>
        <el-form-item label="字辈谱" style="width: 90%">
          <table
            border="1"
            cellspacing="0"
            cellpadding="10"
            width="100%"
            align="center"
          >
            <thead>
              <tr class="firstHead">
                <th style="text-align: center">世序</th>
                <th style="text-align: center">辈分</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in zbpData.content"
                :key="index"
                v-if="zbpData.content.length > 0"
              >
                <td>
                  <el-input
                    v-model="item.shixu"
                    style="width: 100%; margin: 5px 10px 0 0"
                  ></el-input>
                </td>
                <td>
                  <el-input
                    v-model="item.beifen"
                    style="width: 100%; margin: 5px 10px 0 0"
                  ></el-input>
                </td>
              </tr>
            </tbody>
          </table>
          <i class="el-icon-plus" @click="addZbp()" style="cursor: pointer">
            添加字辈</i
          >
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="zbpDialog = false">取 消</el-button>
        <el-button type="primary" @click="zbpSubmit()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 家族成员信息 -->
    <el-dialog :visible.sync="cyxxDialog" width="90%" height="100%">
      <el-form ref="form" :model="cyxxData" label-width="80px">
        <el-form-item label="名称">
          <el-input placeholder="请输入内容" v-model="cyxxData.name"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input
            placeholder="请输入内容"
            v-model="cyxxData.orders"
          ></el-input>
        </el-form-item>
        <el-form-item label="家族成员信息（世系图）">
          <el-input
            type="text"
            v-model="chapterAddData.treeName"
            @focus="mTree()"
            autocomplete="off"
            style="width: 700px; margin: 0 10px 10px 0"
          ></el-input>
          <el-button type="primary" @click="getInfo()">获取</el-button>
          <el-input
            type="textarea"
            :rows="5"
            placeholder="请输入内容"
            v-model="cyxxData.content"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cyxxDialog = false">取 消</el-button>
        <el-button type="primary" @click="cyxxSubmit()">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="jzzpDialog" width="90%" height="100%">
      <el-form ref="form" :model="jzzpData" label-width="80px">
        <el-form-item label="名称">
          <el-input placeholder="请输入内容" v-model="jzzpData.name"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="jzzpDialog = false">取 消</el-button>
        <el-button type="primary" @click="jzzpSubmit()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 传记艺文 -->
    <el-dialog :visible.sync="cjywDialog" width="90%" height="100%">
      <el-form ref="form" :model="cjywData" label-width="80px">
        <el-form-item label="名称">
          <el-input placeholder="请输入内容" v-model="cjywData.name"></el-input>
        </el-form-item>
        <el-form-item label="传记艺文">
          <!--          <quill-editor-->
          <!--            ref="myQuillEditor"-->
          <!--            v-model="cjywData.content"-->
          <!--            :options="editorOption"-->
          <!--            @blur="onEditorBlur($event)"-->
          <!--            @focus="onEditorFocus($event)"-->
          <!--            @ready="onEditorReady($event)"-->
          <!--          />-->
          <vue-ueditor-wrap
            v-model="cjywData.content"
            editor-id="editor8"
            :config="editorConfig"
            :editorDependencies="['ueditor.config.js', 'ueditor.all.js']"
            style="height: 100%"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cjywDialog = false">取 消</el-button>
        <el-button type="primary" @click="cjywSubmit()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 坟茔碑文 -->
    <el-dialog :visible.sync="wybwDialog" width="90%" height="100%">
      <el-form ref="form" :model="wybwData" label-width="80px">
        <el-form-item label="名称">
          <el-input placeholder="请输入内容" v-model="wybwData.name"></el-input>
        </el-form-item>
        <el-form-item label="坟茔碑文">
          <!--          <quill-editor-->
          <!--            ref="myQuillEditor"-->
          <!--            v-model="wybwData.content"-->
          <!--            :options="editorOption"-->
          <!--            @blur="onEditorBlur($event)"-->
          <!--            @focus="onEditorFocus($event)"-->
          <!--            @ready="onEditorReady($event)"-->
          <!--          />-->
          <vue-ueditor-wrap
            v-model="wybwData.content"
            editor-id="editor9"
            :config="editorConfig"
            :editorDependencies="['ueditor.config.js', 'ueditor.all.js']"
            style="height: 100%"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="wybwDialog = false">取 消</el-button>
        <el-button type="primary" @click="wybwSubmit()">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="ctDialog" width="90%" height="100%">
      <el-form ref="form" :model="ctData" label-width="80px">
        <el-form-item label="名称">
          <el-input placeholder="请输入内容" v-model="ctData.name"></el-input>
        </el-form-item>
        <el-form-item label="祠堂">
          <!--          <quill-editor-->
          <!--            ref="myQuillEditor"-->
          <!--            v-model="ctData.content"-->
          <!--            :options="editorOption"-->
          <!--            @blur="onEditorBlur($event)"-->
          <!--            @focus="onEditorFocus($event)"-->
          <!--            @ready="onEditorReady($event)"-->
          <!--          />-->
          <vue-ueditor-wrap
            v-model="ctData.content"
            editor-id="editor10"
            :config="editorConfig"
            :editorDependencies="['ueditor.config.js', 'ueditor.all.js']"
            style="height: 100%"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="ctDialog = false">取 消</el-button>
        <el-button type="primary" @click="ctSubmit()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 大事记 -->
    <el-dialog :visible.sync="dsjDialog" width="90%" height="100%">
      <el-form ref="form" :model="dsjData" label-width="80px">
        <el-form-item label="名称">
          <el-input placeholder="请输入内容" v-model="dsjData.name"></el-input>
        </el-form-item>
        <el-form-item label="大事记">
          <!--          <quill-editor-->
          <!--            ref="myQuillEditor"-->
          <!--            v-model="dsjData.content"-->
          <!--            :options="editorOption"-->
          <!--            @blur="onEditorBlur($event)"-->
          <!--            @focus="onEditorFocus($event)"-->
          <!--            @ready="onEditorReady($event)"-->
          <!--          />-->
          <vue-ueditor-wrap
            v-model="dsjData.content"
            editor-id="editor11"
            :config="editorConfig"
            :editorDependencies="['ueditor.config.js', 'ueditor.all.js']"
            style="height: 100%"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dsjDialog = false">取 消</el-button>
        <el-button type="primary" @click="dsjSubmit()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 编委会 -->
    <el-dialog :visible.sync="bwhDialog" width="90%" height="100%">
      <el-form ref="form" :model="bwhData" label-width="80px">
        <el-form-item label="名称">
          <el-input placeholder="请输入内容" v-model="bwhData.name"></el-input>
        </el-form-item>
        <el-form-item label="照片">
          <div
            class="demo-image__preview avatorSpan"
            v-for="(item, index) in bwhData.avator"
            :key="index"
          >
            <i class="el-icon-close" @click="delavator(bwhData, index)"></i>
            <el-image :src="item"></el-image>
          </div>
          <div class="avator" @click="clickfile">
            <img v-if="bwhData.img || ''" alt="" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </div>
          <input
            type="file"
            name=""
            ref="file"
            accept="image/jpeg,image/jpg,image/png"
            @change="changeImage"
            style="display: none"
          />
        </el-form-item>
        <el-form-item label="主编">
          <el-input
            placeholder="请输入主编姓名"
            v-model="bwhData.zhubian"
          ></el-input>
        </el-form-item>
        <el-form-item label="副主编">
          <el-input
            placeholder="请输入副主编姓名"
            v-model="bwhData.fuzhubian"
          ></el-input>
        </el-form-item>
        <el-form-item label="编委">
          <el-input
            placeholder="请输入编委姓名"
            v-model="bwhData.bianwei"
          ></el-input>
        </el-form-item>
        <el-form-item label="成员简介">
          <!--          <quill-editor-->
          <!--            ref="myQuillEditor"-->
          <!--            v-model="bwhData.cyjj"-->
          <!--            :options="editorOption"-->
          <!--            @blur="onEditorBlur($event)"-->
          <!--            @focus="onEditorFocus($event)"-->
          <!--            @ready="onEditorReady($event)"-->
          <!--          />-->
          <vue-ueditor-wrap
            v-model="bwhData.cyjj"
            editor-id="editor12"
            :config="editorConfig"
            :editorDependencies="['ueditor.config.js', 'ueditor.all.js']"
            style="height: 100%"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="bwhDialog = false">取 消</el-button>
        <el-button type="primary" @click="bwhSubmit()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 后记 -->
    <el-dialog :visible.sync="hjDialog" width="90%" height="100%">
      <el-form ref="form" :model="hjData" label-width="80px">
        <el-form-item label="名称">
          <el-input placeholder="请输入内容" v-model="hjData.name"></el-input>
        </el-form-item>
        <el-form-item label="后记">
          <!--          <quill-editor-->
          <!--            ref="myQuillEditor"-->
          <!--            v-model="hjData.content"-->
          <!--            :options="editorOption"-->
          <!--            @blur="onEditorBlur($event)"-->
          <!--            @focus="onEditorFocus($event)"-->
          <!--            @ready="onEditorReady($event)"-->
          <!--          />-->
          <vue-ueditor-wrap
            v-model="hjData.content"
            editor-id="editor13"
            :config="editorConfig"
            :editorDependencies="['ueditor.config.js', 'ueditor.all.js']"
            style="height: 100%"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="hjDialog = false">取 消</el-button>
        <el-button type="primary" @click="hjSubmit()">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="chapterDialog" width="90%" height="100%">
      <el-form ref="form" :model="memberchapterData" label-width="80px">
        <el-form-item label="章节名称">
          <el-input v-model="memberchapterData.name"></el-input>
        </el-form-item>
        <el-form-item label="父支系">
          <el-input
            type="text"
            v-model="memberchapterData.sxTreeName"
            @focus="sxTree(memberchapterData.bid)"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="从他开始">
          <el-input
            type="text"
            v-model="memberchapterData.treeName"
            @focus="mTree()"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="以下几代">
          <el-input
            type="number"
            v-model="memberchapterData.num"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="chapterDialog = false">取 消</el-button>
        <el-button type="primary" @click="memberChapterAddOrUpdate()"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog :visible.sync="dialogTree" width="500" class="dialogTree">
      <el-tree
        :data="treeData"
        :props="defaultProps"
        @node-click="handleNodeClick"
        :default-expand-all="true"
        :expand-on-click-node="false"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span
            :style="{
              'font-size': '14px',
              color: data.sex == 1 ? '#ffabd5' : '',
            }"
          >
            {{ data.xm }}</span
          >
          <span> [{{ toChies(data.shixu) }}世]</span>
          <span v-if="data.ph != 0"
            >[{{ data.sex == 0 ? "" : "女" }}行{{
              data.ph == 0 ? "一" : toChies(data.ph)
            }}
            ]</span
          >
        </span>
      </el-tree>
    </el-dialog>

    <el-dialog :visible.sync="sxDialogTree" width="500" class="dialogTree">
      <el-tree
        :data="sxTreeData"
        :props="defaultProps"
        @node-click="handleSxNodeClick"
        :default-expand-all="true"
        :expand-on-click-node="false"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span>{{ data.name }}</span>
        </span>
      </el-tree>
    </el-dialog>

    <el-dialog :visible.sync="uploadAvator" width="60%" @close="closeFun">
      <div style="width: 100%; height: 400px">
        <vue-cropper autoCrop :img="imageUrl" ref="cropper" centerBox />
      </div>
      <el-button
        type="primary"
        @click="getCropData()"
        block
        style="margin: 10px 0"
        >上传</el-button
      >
    </el-dialog>
    <!-- 家族成员信息点击弹窗 -->
    <el-dialog :visible.sync="infoDialog" width="90%"  class="infoDialog"  @close="resetScroll">
      <div class="infoDiv" >
        <h1 v-html="title"></h1>
        <div class="con" v-html="content"></div>
      </div>
    </el-dialog>
  </div>
</template>
 <script>
import Head from "@/components/header.vue";
import api from "@/request/api";
import treeSelect from "@/components/treeSelect.vue";
import coverCom from '@/components/coverCom.vue'
import readerMobileCom from '@/components/readerMobileCom.vue'

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";

import VueUeditorWrap from "vue-ueditor-wrap";
import pdfjs from "@/components/pdfjsA.vue";
//  import pdfjs from "@/components/pdfjsApp.vue";

export default {
  data() {
    return {
      uploadobj: "",
      uploadAvator: false,
      imageUrl: "",
      pdfUrl: "",
      familyData: {},
      treeProps: {
        // 修改el-tree默认data数组参数
        children: "children",
        label: "name",
        id: "id",
        parentId: "parentId",
        isLeaf: "leaf", // 指定节点是否为叶子节点，仅在指定了 lazy 属性的情况下生效
      },
      text: "祖宗像赞",
      activeClass: "",
      shareBookList: [],
      mySelfBookList: [],
      addDialog: false,
      dialogType: "",
      bookAddData: {
        name: "",
        intro: "",
        open: 0,
      },
      cDialogType: "",
      chapterDialog: false,
      chapterAddData: {
        name: "",
        content: "",
        treeName: "",
        num: 5,
        type: 0,
      },
      submitData: {
        id: 0,
        bid: 0,
        name: "",
        content: "",
      },
      conData: {
        sheng: "",
        shi: "",
        xian: "",
        zhen: "",
        cun: "",
        bzwyh: "",
        bzdate: "",
        jh: "",
        zzxz: "",
        xstt: "",
        pltc: "",
        fl: "",
        xsyl: "",
        jpxy: "",
        jg: "",
        jx: "",
        zbp: "",
        cyxx: "",
        jzzp: "",
        cjyw: "",
        wybw: "",
        ct: "",
        dsj: "",
        bwh: "",
        hj: "",
      },
      psfmData: {
        bid: "",
        id: "",
        psmc: "",
        psdz: "",
        bzr: "",
        bzsj: "",
        jh: "",
        avator: [],
      },
      zzxzData: {
        bid: "", //谱书的ID
        id: "",
        name: "", //名称
        content: "", //内容
        avator: [],
      },
      xsttData: {
        bid: "", //谱书的ID
        id: "",
        name: "", //名称
        content: "", //内容
        avator: [],
      },
      pltcData: {
        bid: "", //谱书的ID
        id: "",
        name: "", //名称
        content: "", //内容
      },
      flData: {
        bid: "", //谱书的ID
        id: "",
        name: "", //名称
        content: "", //内容
      },
      xsylData: {
        bid: "", //谱书的ID
        id: "",
        name: "", //名称
        content: "", //内容
      },
      jpxyData: {
        bid: "", //谱书的ID
        id: "",
        name: "", //名称
        content: "", //内容
      },
      jgData: {
        bid: "", //谱书的ID
        id: "",
        name: "", //名称
        content: "", //内容
      },
      jxData: {
        bid: "", //谱书的ID
        id: "",
        name: "", //名称
        content: "", //内容
      },
      zbpData: {
        bid: "", //谱书的ID
        id: "",
        name: "", //名称
        content: [], //内容
      },
      cyxxData: {
        bid: "", //谱书的ID
        orders: "", //排序
        type: 9, //类型
        name: "", //名称
        content: "", //内容
      },
      jzzpData: {
        bid: "", //谱书的ID
        orders: "", //排序
        type: 10, //类型
        name: "", //名称
        content: "", //内容
      },
      cjywData: {
        bid: "", //谱书的ID
        id: "",
        name: "", //名称
        content: "", //内容
      },
      wybwData: {
        bid: "", //谱书的ID
        id: "",
        name: "", //名称
        content: "", //内容
      },
      ctData: {
        bid: "", //谱书的ID
        id: "",
        name: "", //名称
        content: "", //内容
      },
      dsjData: {
        bid: "", //谱书的ID
        id: "",
        name: "", //名称
        content: "", //内容
      },
      bwhData: {
        bid: "", //谱书的ID
        id: "",
        name: "", //名称
        zhubian: "",
        fuzhubian: "",
        bianwei: "",
        cyjj: "",
        avator: [],
      },
      hjData: {
        bid: "", //谱书的ID
        id: "",
        name: "", //名称
        content: "", //内容
      },
      memberchapterData: {
        bid: 0,
        fid: 0,
        id: 0,
        name: "",
        treeName: "",
        sxTreeName: "",
        mid: 0,
        num: 5,
      },
      chapterListData: {},
      type: null,
      title: "",
      content: "",
      infoDialog:false,
      treeData: {},
      sxTreeData: {},
      isClearable: true, // 可清空（可选）
      isAccordion: true, // 可收起（可选）
      valueId: "",
      dialogTree: false,
      sxDialogTree: false,
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
            ["blockquote", "code-block"], // 引用  代码块
            [{ header: 1 }, { header: 2 }], // 1、2 级标题
            [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
            [{ script: "sub" }, { script: "super" }], // 上标/下标
            [{ indent: "-1" }, { indent: "+1" }], // 缩进
            [{ direction: "rtl" }], // 文本方向
            [
              {
                size: [
                  "12",
                  "14",
                  "16",
                  "18",
                  "20",
                  "22",
                  "24",
                  "28",
                  "32",
                  "36",
                ],
              },
            ], // 字体大小
            [{ header: [1, 2, 3, 4, 5, 6] }], // 标题
            [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
            // [{ font: ['songti'] }], // 字体种类
            [{ align: [] }], // 对齐方式
            ["clean"], // 清除文本格式
          ],
        },
        placeholder: "请输入正文",
      },
      defaultProps: {
        children: "children",
        label: "xm",
      },
      psfmDialog: false,
      zzxzDialog: false,
      xsttDialog: false,
      pltcDialog: false,
      flDialog: false,
      xsylDialog: false,
      jpxyDialog: false,
      jgDialog: false,
      jxDialog: false,
      zbpDialog: false,
      cyxxDialog: false,
      jzzpDialog: false,
      cjywDialog: false,
      wybwDialog: false,
      ctDialog: false,
      dsjDialog: false,
      bwhDialog: false,
      hjDialog: false,
      editorConfig: {
        serverUrl: "/config",
        //前端资源
        UEDITOR_HOME_URL: "/static/UEditor/",
        UEDITOR_CORS_URL: "/static/UEditor/",
        zIndex: 99999, //设置z轴顺序值，避免工具栏下拉组件被遮挡
      },
      flag:'pc',
        //新的右侧谱书展示形式数据
      bookCatalog:[],//如果用到目录的话，这个是目录数据
      //封面数据
      coverData:{},//封面数据
      coverShow:0,//是否展示封面 0 刚开始不展示 1 展示封面 2 展示其他页面数据
      coverFlag:false,
      readerData:[],//谱书数据
      chapMap:{},//点击封面下一页的id  或者主页面数据上下页获取数据的id
      chapMapIndex:1,
    };
  },
  mounted() {
    this.flag=sessionStorage.getItem("flag")
    console.log(this.flag,'----flag')

    api.familyGet(localStorage.getItem("fid")).then((res) => {
      this.familyData = res.data;
    });
    this.booklist();
    setTimeout(() => {
      this.html = "<p>模拟 Ajax 异步设置内容 HTML</p>";
    }, 1500);
    api.listtreename({ fid: localStorage.getItem("fid") }).then((res) => {
      this.treeData = res.data;
    });
  },
  methods: {
   
    viewpdf(data) {
      const loading = this.$loading({
        lock: true,
        text: "谱书生成中，请稍后……",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      api.bookPdf(data.id).then((res) => {
        var timer = setTimeout(function () {
          loading.close();
        }, 300);
        this.type = 100;
        this.pdfUrl = "https://www.xsdjp.com" + res.data;
        // console.log(this.pdfUrl,'-----父页面url')
      });
    },
    chapterClick(data) {},
    booklist() {
      api.bookList(localStorage.getItem("fid")).then((res) => {
        this.mySelfBookList = res.data.myself;
        this.shareBookList = res.data.share;
      });
    },
    getInfo() {
      api
        .getInfo(
          this.$qs.stringify({
            fid: localStorage.getItem("fid"),
            mid: this.chapterAddData.mid,
            num: this.chapterAddData.num,
          })
        )
        .then((res) => {
          // this.bookList = res.data;
          // this.chapterAddData.content = res.data;
          for (let i = 0; i < res.data.length; i++) {
            this.conData.cyxx += res.data[i].info;
          }
        });
    },
    //添加谱书弹窗
    addScoreBook(type) {
      if (type == "add") {
        this.bookAddData = {
          name: "",
          intro: "",
          open: 0,
        };
        this.addDialog = true;
      }
      this.dialogType = type;
      // console.log(this.bookAddData,'----data')
    },
    bookSubmit() {
      // console.log(this.dialogType,'----dialogType')
      // console.log(this.bookAddData,'----this.bookAddData')
      if (this.dialogType == "add") {
        this.bookAddData.fid = localStorage.getItem("fid");
        api.bookAdd(this.bookAddData).then((res) => {
          if (res.code == 0) {
            this.bookAddData = {
              name: "",
              intro: "" /* , postdate: "", lastupdate: "" */,
            };
            this.booklist();
            this.addDialog = false;
            this.$message({
              message: "操作成功",
            });
          }
        });
      } else {
        api.bookEdit(this.bookAddData).then((res) => {
          if (res.code == 0) {
            this.bookAddData = {
              name: "",
              intro: "" /* , postdate: "", lastupdate: "" */,
            };
            this.booklist();
            this.addDialog = false;
            this.$message({
              message: "操作成功",
            });
          }
        });
      }
    },
    bookDel(data) {
      this.$alert("确定删除吗?", {
        confirmButtonText: "确定",
        customClass: "msgAlertBox",
        callback: (action) => {
          if (action == "confirm") {
            api.bookDel(this.$qs.stringify({ id: data.id })).then((res) => {
              if (res.code == 0) {
                this.booklist();
              } else {
                this.$message({
                  message: res.msg,
                  type: "warning",
                });
              }
            });
          }
        },
      });
    },
    bookEdit(data) {
      this.dialogType = "edit";
      this.addDialog = true;
      this.bookAddData = data;
    },

    chapterList(id) {
      api.chapterList(this.$qs.stringify({ bid: id })).then((res) => {
        if (res.code == 0) {
          this.$set(this.chapterListData, id, res.data);
          this.bookCatalog=this.chapterListData
        }
      });
      this.getCoverData(id)
    },
     //获取封面数据
     getCoverData(id){
      api.chapterGet(this.$qs.stringify({ id: id })).then((res) => {
          if (res.code == 0) {
            // console.log(res.data,'-0000----data')
            this.coverData=JSON.parse(res.data.content); 
            // console.log(this.coverData,'------coverData封面数据')
            this.type = '-1';//自己新加的
            this.coverShow=1
            this.coverFlag=true
          }
        });
    },
    //点击下一页
    nextBtn(){
      this.coverShow=2
      // console.log(this.chapterListData[1],'-------目录')
      this.chapMap=this.chapterListData[1][1]
      this.chapMapIndex=1
      this.coverFlag=true
      // console.log(this.chapMap,'传递数据')
      // console.log(this.chapMap.id,'------id')
    },
    //返回封面
    coverFun(data) {
      this.coverShow=1;//显示封面
      // this.coverFlag=false
      this.coverFlag=true
      this.getCoverData(this.chapterListData[1][0]['id'])
    },
    psfmSubmit() {
      this.submitData.bid = this.psfmData.bid;
      this.submitData.id = this.psfmData.id;
      this.submitData.name = this.psfmData.name;
      this.submitData.content = JSON.stringify(this.psfmData);
      api.chapterEdit(this.submitData).then((res) => {
        if (res.code == 0) {
          this.booklist();
          this.psfmDialog = false;
          this.$message({
            message: "操作成功",
          });
        }
      });
    },
    zzxzSubmit() {
      this.submitData.bid = this.zzxzData.bid;
      this.submitData.id = this.zzxzData.id;
      this.submitData.name = this.zzxzData.name;
      this.submitData.content = JSON.stringify(this.zzxzData);
      api.chapterEdit(this.submitData).then((res) => {
        if (res.code == 0) {
          this.booklist();
          this.zzxzDialog = false;
          this.$message({
            message: "操作成功",
          });
        }
      });
    },
    xsttSubmit() {
      this.submitData.bid = this.xsttData.bid;
      this.submitData.id = this.xsttData.id;
      this.submitData.name = this.xsttData.name;
      this.submitData.content = JSON.stringify(this.xsttData);
      api.chapterEdit(this.submitData).then((res) => {
        if (res.code == 0) {
          this.booklist();
          this.xsttDialog = false;
          this.$message({
            message: "操作成功",
          });
        }
      });
    },
    pltcSubmit() {
      this.submitData.bid = this.pltcData.bid;
      this.submitData.id = this.pltcData.id;
      this.submitData.name = this.pltcData.name;
      this.submitData.content = JSON.stringify(this.pltcData);
      api.chapterEdit(this.submitData).then((res) => {
        if (res.code == 0) {
          this.booklist();
          this.pltcDialog = false;
          this.$message({
            message: "操作成功",
          });
        }
      });
    },
    flSubmit() {
      this.submitData.bid = this.flData.bid;
      this.submitData.id = this.flData.id;
      this.submitData.name = this.flData.name;
      this.submitData.content = JSON.stringify(this.flData);
      api.chapterEdit(this.submitData).then((res) => {
        if (res.code == 0) {
          this.booklist();
          this.flDialog = false;
          this.$message({
            message: "操作成功",
          });
        }
      });
    },
    xsylSubmit() {
      this.submitData.bid = this.xsylData.bid;
      this.submitData.id = this.xsylData.id;
      this.submitData.name = this.xsylData.name;
      this.submitData.content = JSON.stringify(this.xsylData);
      api.chapterEdit(this.submitData).then((res) => {
        if (res.code == 0) {
          this.booklist();
          this.xsylDialog = false;
          this.$message({
            message: "操作成功",
          });
        }
      });
    },
    jpxySubmit() {
      this.submitData.bid = this.jpxyData.bid;
      this.submitData.id = this.jpxyData.id;
      this.submitData.name = this.jpxyData.name;
      this.submitData.content = JSON.stringify(this.jpxyData);
      api.chapterEdit(this.submitData).then((res) => {
        if (res.code == 0) {
          this.booklist();
          this.jpxyDialog = false;
          this.$message({
            message: "操作成功",
          });
        }
      });
    },
    jgSubmit() {
      this.submitData.bid = this.jgData.bid;
      this.submitData.id = this.jgData.id;
      this.submitData.name = this.jgData.name;
      this.submitData.content = JSON.stringify(this.jgData);
      api.chapterEdit(this.submitData).then((res) => {
        if (res.code == 0) {
          this.booklist();
          this.jgDialog = false;
          this.$message({
            message: "操作成功",
          });
        }
      });
    },
    jxSubmit() {
      this.submitData.bid = this.jxData.bid;
      this.submitData.id = this.jxData.id;
      this.submitData.name = this.jxData.name;
      this.submitData.content = JSON.stringify(this.jxData);
      api.chapterEdit(this.submitData).then((res) => {
        if (res.code == 0) {
          this.booklist();
          this.jxDialog = false;
          this.$message({
            message: "操作成功",
          });
        }
      });
    },
    addZbp(index) {
      this.zbpData.content.push({});
    },
    zbpSubmit() {
      this.submitData.bid = this.zbpData.bid;
      this.submitData.id = this.zbpData.id;
      this.submitData.name = this.zbpData.name;
      this.submitData.content = JSON.stringify(this.zbpData);
      api.chapterEdit(this.submitData).then((res) => {
        if (res.code == 0) {
          this.booklist();
          this.zbpDialog = false;
          this.$message({
            message: "操作成功",
          });
        }
      });
    },
    cyxxSubmit() {
      api.chapterAdd(this.cyxxData).then((res) => {
        if (res.code == 0) {
          this.booklist();
          this.$message({
            message: "操作成功",
          });
        }
      });
    },
    jzzpSubmit() {
      api.chapterAdd(this.jzzpData).then((res) => {
        if (res.code == 0) {
          this.booklist();
          this.$message({
            message: "操作成功",
          });
        }
      });
    },
    cjywSubmit() {
      this.submitData.bid = this.cjywData.bid;
      this.submitData.id = this.cjywData.id;
      this.submitData.name = this.cjywData.name;
      this.submitData.content = JSON.stringify(this.cjywData);
      api.chapterEdit(this.submitData).then((res) => {
        if (res.code == 0) {
          this.booklist();
          this.cjywDialog = false;
          this.$message({
            message: "操作成功",
          });
        }
      });
    },
    wybwSubmit() {
      this.submitData.bid = this.wybwData.bid;
      this.submitData.id = this.wybwData.id;
      this.submitData.name = this.wybwData.name;
      this.submitData.content = JSON.stringify(this.wybwData);
      api.chapterEdit(this.submitData).then((res) => {
        if (res.code == 0) {
          this.booklist();
          this.wybwDialog = false;
          this.$message({
            message: "操作成功",
          });
        }
      });
    },
    ctSubmit() {
      this.submitData.bid = this.ctData.bid;
      this.submitData.id = this.ctData.id;
      this.submitData.name = this.ctData.name;
      this.submitData.content = JSON.stringify(this.ctData);
      api.chapterEdit(this.submitData).then((res) => {
        if (res.code == 0) {
          this.booklist();
          this.ctDialog = false;
          this.$message({
            message: "操作成功",
          });
        }
      });
    },
    dsjSubmit() {
      this.submitData.bid = this.dsjData.bid;
      this.submitData.id = this.dsjData.id;
      this.submitData.name = this.dsjData.name;
      this.submitData.content = JSON.stringify(this.dsjData);
      api.chapterEdit(this.submitData).then((res) => {
        if (res.code == 0) {
          this.booklist();
          this.dsjDialog = false;
          this.$message({
            message: "操作成功",
          });
        }
      });
    },
    bwhSubmit() {
      this.submitData.bid = this.bwhData.bid;
      this.submitData.id = this.bwhData.id;
      this.submitData.name = this.bwhData.name;
      this.submitData.content = JSON.stringify(this.bwhData);
      api.chapterEdit(this.submitData).then((res) => {
        if (res.code == 0) {
          this.booklist();
          this.bwhDialog = false;
          this.$message({
            message: "操作成功",
          });
        }
      });
    },

    hjSubmit() {
      this.submitData.bid = this.hjData.bid;
      this.submitData.id = this.hjData.id;
      this.submitData.name = this.hjData.name;
      this.submitData.content = JSON.stringify(this.hjData);
      api.chapterEdit(this.submitData).then((res) => {
        if (res.code == 0) {
          this.booklist();
          this.hjDialog = false;
          this.$message({
            message: "操作成功",
          });
        }
      });
    },

    memberChapterAddOrUpdate() {
      if (this.cDialogType == "add") {
        this.memberchapterData.id = 0;
        this.submitData.bid = this.memberchapterData.bid;
        this.submitData.fid = this.memberchapterData.fid;
        this.submitData.name = this.memberchapterData.name;
        this.submitData.content = JSON.stringify(this.memberchapterData);
        console.log(this.submitData);
        api.chapterAdd(this.submitData).then((res) => {
          if (res.code == 0) {
            this.booklist();
            this.chapterDialog = false;
            this.$message({
              message: "操作成功",
            });
          }
        });
      } else {
        this.submitData.bid = this.memberchapterData.bid;
        this.submitData.fid = this.memberchapterData.fid;
        this.submitData.id = this.memberchapterData.id;
        this.submitData.name = this.memberchapterData.name;
        this.submitData.content = JSON.stringify(this.memberchapterData);
        api.chapterEdit(this.submitData).then((res) => {
          if (res.code == 0) {
            this.booklist();
            this.chapterDialog = false;
            this.$message({
              message: "操作成功",
            });
          }
        });
      }
    },

    chapterSubmit() {
      this.chapterAddData.content = JSON.stringify(this.conData);
      if (this.cDialogType == "add") {
        api.chapterAdd(this.chapterAddData).then((res) => {
          if (res.code == 0) {
            this.booklist();
            this.chapterList(this.chapterAddData.bid);
            this.chapterAddData = { name: "", orders: "", content: "" };
            this.chapterDialog = false;
            this.$message({
              message: "操作成功",
            });
          }
        });
      } else {
        api.chapterEdit(this.chapterAddData).then((res) => {
          if (res.code == 0) {
            this.booklist();
            this.chapterList(this.chapterAddData.bid);
            this.chapterAddData = { name: "", orders: "", content: "" };
            this.chapterDialog = false;
            this.$message({
              message: "操作成功",
            });
          }
        });
      }
    },
    handleChange(val) {
      if (val) {
        this.chapterList(val);
      }
    },
    handleChange1(val) {
      // this.chapterList(val);
    },
    chapterDel(id, bid) {
      this.$alert("确定删除吗?", {
        confirmButtonText: "确定",
        customClass: "msgAlertBox",
        callback: (action) => {
          if (action == "confirm") {
            api.chapterDel(this.$qs.stringify({ id: id })).then((res) => {
              if (res.code == 0) {
                this.booklist();
                this.chapterList(bid);
              } else {
                this.$message({
                  message: res.msg,
                  type: "warning",
                });
              }
            });
          }
        },
      });
    },
    chapterEdit(data) {
      this.cDialogType = "edit";
      this.chapterDialog = true;
      this.chapterAddData = data;
      this.chapterAddData.treeName = this.getTreeName(this.treeData, data.mid);
      this.chapterAddData.num = this.chapterAddData.num
        ? this.chapterAddData.num
        : 5;
      api.listtreename({ fid: localStorage.getItem("fid") }).then((res) => {
        this.treeData = res.data;
      });
    },
    getTreeName(list, id) {
      let _this = this;
      for (let i = 0; i < list.length; i++) {
        let a = list[i];
        if (a.id === id) {
          return a.xm;
        } else {
          if (a.children && a.children.length > 0) {
            let res = _this.getTreeName(a.children, id);
            if (res) {
              return res;
            }
          }
        }
      }
    },
    addFun(data) {
      console.log(data);
      switch (data.type) {
        case 9:
          this.memberchapterData.fid = data.id;
          this.memberchapterData.bid = data.bid;
          this.memberchapterData.name = "";
          this.memberchapterData.id = 0;
          this.memberchapterData.treeName = "";
          this.memberchapterData.num = 5;
          this.cDialogType = "add";
          this.chapterDialog = true;
          break;
        case 10:
          break;
      }
    },
    editFun(data) {
      switch (data.type) {
        case 0: //封面
          this.uploadobj = this.psfmData;
          this.psfmData.id = data.id;
          this.psfmData.bid = data.bid;
          this.psfmData.name = data.name;
          api.chapterGet(this.$qs.stringify({ id: data.id })).then((res) => {
            if (res.code == 0) {
              if (res.data.content) {
                var js = JSON.parse(res.data.content);
                console.log(js.psmc);
                this.psfmData.psmc = js.psmc;
                this.psfmData.psdz = js.psdz;
                this.psfmData.bzr = js.bzr;
                this.psfmData.bzsj = js.bzsj;
                this.psfmData.xs = js.xs;
                this.psfmData.jh = js.jh;
              }
            }
          });
          this.psfmDialog = true;
          break;
        case 1: //祖宗像赞
          this.uploadobj = this.zzxzData;
          this.zzxzData.id = data.id;
          this.zzxzData.bid = data.bid;
          this.zzxzData.name = data.name;
          api.chapterGet(this.$qs.stringify({ id: data.id })).then((res) => {
            if (res.code == 0) {
              if (res.data.content) {
                var js = JSON.parse(res.data.content);
                this.zzxzData.content = js.content;
                this.zzxzData.avator = js.avator;
              }
            }
          });
          this.zzxzDialog = true;
          break;
        case 2: //姓氏图腾
          this.uploadobj = this.xsttData;
          this.xsttData.id = data.id;
          this.xsttData.bid = data.bid;
          this.xsttData.name = data.name;
          api.chapterGet(this.$qs.stringify({ id: data.id })).then((res) => {
            if (res.code == 0) {
              if (res.data.content) {
                var js = JSON.parse(res.data.content);
                this.xsttData.content = js.content;
                this.xsttData.avator = js.avator;
              }
            }
          });
          this.xsttDialog = true;
          break;
        case 3: //谱论题词
          this.pltcData.id = data.id;
          this.pltcData.bid = data.bid;
          this.pltcData.name = data.name;
          api.chapterGet(this.$qs.stringify({ id: data.id })).then((res) => {
            if (res.code == 0) {
              if (res.data.content) {
                var js = JSON.parse(res.data.content);
                this.pltcData.content = js.content;
              }
            }
          });
          this.pltcDialog = true;

          break;
        case 4: //凡例
          this.flData.id = data.id;
          this.flData.bid = data.bid;
          this.flData.name = data.name;
          api.chapterGet(this.$qs.stringify({ id: data.id })).then((res) => {
            if (res.code == 0) {
              if (res.data.content) {
                var js = JSON.parse(res.data.content);
                this.flData.content = js.content;
              }
            }
          });
          this.flDialog = true;
          break;
        case 5: //姓氏源流
          this.xsylData.id = data.id;
          this.xsylData.bid = data.bid;
          this.xsylData.name = data.name;
          api.chapterGet(this.$qs.stringify({ id: data.id })).then((res) => {
            if (res.code == 0) {
              if (res.data.content) {
                var js = JSON.parse(res.data.content);
                this.xsylData.content = js.content;
              }
            }
          });
          this.xsylDialog = true;
          break;
        case 6: //家谱序言
          this.jpxyData.id = data.id;
          this.jpxyData.bid = data.bid;
          this.jpxyData.name = data.name;
          api.chapterGet(this.$qs.stringify({ id: data.id })).then((res) => {
            if (res.code == 0) {
              if (res.data.content) {
                var js = JSON.parse(res.data.content);
                this.jpxyData.content = js.content;
              }
            }
          });
          this.jpxyDialog = true;
          break;
        case 7: //家规
          this.jgData.id = data.id;
          this.jgData.bid = data.bid;
          this.jgData.name = data.name;
          api.chapterGet(this.$qs.stringify({ id: data.id })).then((res) => {
            if (res.code == 0) {
              if (res.data.content) {
                var js = JSON.parse(res.data.content);
                this.jgData.content = js.content;
              }
            }
          });
          this.jgDialog = true;
          break;
        case 17: //家训
          this.jxData.id = data.id;
          this.jxData.bid = data.bid;
          this.jxData.name = data.name;
          api.chapterGet(this.$qs.stringify({ id: data.id })).then((res) => {
            if (res.code == 0) {
              if (res.data.content) {
                var js = JSON.parse(res.data.content);
                this.jxData.content = js.content;
              }
            }
          });
          this.jxDialog = true;
          break;
        case 8: //字辈谱
          this.zbpData.id = data.id;
          this.zbpData.bid = data.bid;
          this.zbpData.name = data.name;
          api.chapterGet(this.$qs.stringify({ id: data.id })).then((res) => {
            if (res.code == 0) {
              if (res.data.content) {
                var js = JSON.parse(res.data.content);
                this.zbpData.content = js.content;
              }
            }
          });
          this.zbpDialog = true;
          break;
        case 11: //"传记艺文":
          this.cjywData.id = data.id;
          this.cjywData.bid = data.bid;
          this.cjywData.name = data.name;
          api.chapterGet(this.$qs.stringify({ id: data.id })).then((res) => {
            if (res.code == 0) {
              if (res.data.content) {
                var js = JSON.parse(res.data.content);
                this.cjywData.content = js.content;
              }
            }
          });
          this.cjywDialog = true;
          break;
        case 12: //"坟茔碑文":
          this.wybwData.id = data.id;
          this.wybwData.bid = data.bid;
          this.wybwData.name = data.name;
          api.chapterGet(this.$qs.stringify({ id: data.id })).then((res) => {
            if (res.code == 0) {
              if (res.data.content) {
                var js = JSON.parse(res.data.content);
                this.wybwData.content = js.content;
              }
            }
          });
          this.wybwDialog = true;
          break;
        case 13: //"祠堂":
          this.ctData.id = data.id;
          this.ctData.bid = data.bid;
          this.ctData.name = data.name;
          api.chapterGet(this.$qs.stringify({ id: data.id })).then((res) => {
            if (res.code == 0) {
              if (res.data.content) {
                var js = JSON.parse(res.data.content);
                this.ctData.content = js.content;
              }
            }
          });
          this.ctDialog = true;
          break;
        case 14: //"大事记":
          this.dsjData.id = data.id;
          this.dsjData.bid = data.bid;
          this.dsjData.name = data.name;
          api.chapterGet(this.$qs.stringify({ id: data.id })).then((res) => {
            if (res.code == 0) {
              if (res.data.content) {
                var js = JSON.parse(res.data.content);
                this.dsjData.content = js.content;
              }
            }
          });
          this.dsjDialog = true;
          break;
        case 15: //"编委会":
          this.uploadobj = this.bwhData;
          this.bwhData.id = data.id;
          this.bwhData.bid = data.bid;
          this.bwhData.name = data.name;
          api.chapterGet(this.$qs.stringify({ id: data.id })).then((res) => {
            if (res.code == 0) {
              if (res.data.content) {
                var js = JSON.parse(res.data.content);
                this.bwhData.zhubian = js.zhuban;
                this.bwhData.fuzhubian = js.fuzhubian;
                this.bwhData.bianwei = js.bianwei;
                this.bwhData.cyjj = js.cyjj;
                this.bwhData.avator = js.avator;
              }
            }
          });
          this.bwhDialog = true;
          this.bwhData.bid = data.id;
          break;
        case 16: //"后记":
          this.hjData.id = data.id;
          this.hjData.bid = data.bid;
          this.hjData.name = data.name;
          api.chapterGet(this.$qs.stringify({ id: data.id })).then((res) => {
            if (res.code == 0) {
              if (res.data.content) {
                var js = JSON.parse(res.data.content);
                this.hjData.content = js.content;
              }
            }
          });
          this.hjDialog = true;
          break;
        case 98: //世系图
          this.cDialogType = "edit";
          api.chapterGet(this.$qs.stringify({ id: data.id })).then((res) => {
            if (res.code == 0) {
              this.memberchapterData.id = data.id;
              this.memberchapterData.fid = res.data.fid;
              this.memberchapterData.bid = res.data.bid;
              this.memberchapterData.name = res.data.name;
              if (res.data.content) {
                var js = JSON.parse(res.data.content);
                this.memberchapterData.mid = js.mid;
                this.memberchapterData.num = js.num;
                this.memberchapterData.treeName = js.treeName;
              }
            }
          });
          this.chapterDialog = true;
          break;
        case 99: //家族照片
          break;
      }
    },
    // getValue(value) {
    //     // this.valueId = value;
    //     // this.jurisdictionRuleForm.mid = value;

    // },
    mTree() {
      this.dialogTree = true;
    },
    sxTree(id) {
      api.listsxtreename(id).then((res) => {
        this.sxTreeData = res.data;
      });
      this.sxDialogTree = true;
    },
    handleNodeClick(data) {
      this.dialogTree = false;
      this.memberchapterData.mid = data.id;
      this.memberchapterData.treeName = data.xm;
    },
    handleSxNodeClick(data) {
      this.sxDialogTree = false;
      this.memberchapterData.fid = data.id;
      this.memberchapterData.sxTreeName = data.name;
    },
    onEditorBlur(quill) {
      console.log("editor blur!", quill);
    },
    onEditorFocus(quill) {
      console.log("editor focus!", quill);
    },
    onEditorReady(quill) {
      console.log("editor ready!", quill, this, this.value);
    },
    // 上传图片
    clickfile() {
      this.$refs.file.click();
    },
    changeImage(e) {
      var file = e.target.files[0];
      var reader = new FileReader();
      var that = this;
      reader.readAsDataURL(file);
      reader.onload = function (e) {
        that.imageUrl = this.result;
        that.uploadAvator = true;
      };
    },
    closeFun() {
      this.$refs.file.value = "";
    },
    getCropData() {
      this.$refs.cropper.getCropData((data) => {
        // this.zzxzData.avator = data;
        if (this.type == "Edit") {
          api
            .uploadAvator(
              this.$qs.stringify({
                fid: localStorage.getItem("fid"),
                mid: sessionStorage.getItem("memberId"),
                img: data,
              })
            )
            .then((res) => {
              this.uploadobj.avator.push(res.data);
            });
        } else {
          if (this.uploadobj.img == "") {
            this.uploadobj.img = [];
          }
          this.uploadobj.avator.push(data);
        }
        this.uploadAvator = false;
      });
    },
    delavator(data, id) {
      console.log(data);
      console.log(id);
      this.$alert("确定删除吗", {
        confirmButtonText: "确定",
        customClass: "msgAlertBox",
        callback: (action) => {
          if (action == "confirm") {
            data.avator.splice(id, 1);
          }
        },
      });
    },
    view(node, data) {
      if (data.type != 9 && data.type != 10 && data.type != 98) {
        this.content = "";
        api.chapterGet(this.$qs.stringify({ id: data.id })).then((res) => {
          if (res.code == 0) {
            this.type = res.data.type;
            this.title = res.data.name;
            this.content = JSON.parse(res.data.content);
          }
        });
      } else if (data.type == 98) {
        this.content = "";
        this.title = data.name;
        this.type = 98;
        api
          .memberGetinfo(this.$qs.stringify({ mid: data.id, num: 5 }))
          .then((res) => {
            if (res.code == 0) {
              var shixu = "";
              var html = "";
              for (let i in res.data) {
                if (res.data[i].shixu != shixu) {
                  html += "<h1>" + this.toChies(res.data[i].shixu) + "世<h1>";
                  shixu = res.data[i].shixu;
                }
                html += "<h2>" + res.data[i].name + "</h2>";
                html +=
                  "<h3><p>" +
                  res.data[i].info.replace("\n", "</p><p>") +
                  "</p><h3>";
                html += "<br>";
              }
              this.content = html;
              this.infoDialog=true
              console.log(this.content,'---content');
            }
          });
        //this.content = JSON.parse(res.data.content);
      }
    },
    //打开弹窗重置滚动条位置
    resetScroll() {
      const content = this.$el.querySelector('.infoDiv');
      if (content) {
        content.scrollTop = 0;
      }
    },
  },
  computed: {
    toChies(val) {
      return function (val) {
        return this.$utils.toChies(val);
      };
    },
  },
  components: {
    Head,
    treeSelect,
    quillEditor,
    pdfjs,
    VueUeditorWrap,
    coverCom ,
    readerMobileCom
  },
  beforeDestroy() {
    const editor = this.editor;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁编辑器
  },
};
</script>
 <style>
.msgAlertBox {
  width: 100%;
}
@media screen and (min-width: 768px) {
  .msgAlertBox {
    width: 80% !important;
  }
}
</style>
 <style lang="less" scoped>
.scorebook {
  overflow: hidden;
  height: 100%;
  .chartTop {
    height: 55px;
    line-height: 55px;

    h1 {
      width: 350px;
      font-size: 20px;
    }
  }

  .catalogue {
    // width: 300px;
    // height: 100%;
    // float: left;
    padding: 20px 20px 10px 20px;
    box-sizing: border-box;
    border-right: 1px solid #e6e6e6;

    .el-icon-delete,
    .el-icon-edit {
      float: right;
      font-size: 18px;
      margin-left: 5px;
    }
    .liAdd {
      position: relative;
      margin: 10px;
      padding: 10px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 0 4px 2px #0000000f;
      border-radius: 4px;
      cursor: pointer;
    }
    .el-collapse-item {
      .liAdd {
        height: 30px;
        padding: 5px 10px;
      }
      p {
        padding-left: 10px;
        line-height: 30px;
        cursor: pointer;
        span {
          width: 100px;
          display: inline-block;
        }
        i {
          cursor: pointer;
          margin-block: 5px;
        }
      }
    }
  }
  .center {
    // width: calc(100% - 300px);
    // float: right;
    padding: 20px 50px 20px 20px;
    box-sizing: border-box;
    > div {
      > div {
        > img {
          width: 500px;
          margin: 0 auto;
          display: block;
        }
        > p {
          color: #000;
          font-weight: bold;
          text-align: center;
          font-size: 16px;
          margin: 15px 0;
        }
        div {
          text-align: center;
        }
      }
    }

    .bwh {
      div {
        p {
          width: 500px;
          text-align: left;
          margin: 0 auto;
        }
      }
    }
  }
}
.ql-container {
  height: 300px;
}

.avatorSpan {
  display: inline-block;
  height: 120px;
  line-height: 120px;
  width: 88px;
  vertical-align: top;
  margin-right: 10px;
  border: 1px dashed #d9d9d9;
  position: relative;
  text-align: center;

  i {
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
    display: none;
    width: 20px;
    height: 20px;
    line-height: 20px;
    font-size: 16px;
    color: #fff;
    background-color: #606266;
    z-index: 999;
    border-radius: 50%;
  }

  .el-image {
    width: 100%;
    height: 100%;

    /deep/ img {
      width: 90%;
      height: 90%;
      vertical-align: middle;
    }
  }
}

.avatorSpan:hover {
  i {
    display: block;
  }
}

.avator {
  border: 1px dashed #d9d9d9;
  text-align: center;
  cursor: pointer;
  display: inline-block;
  height: 120px;
  width: 88px;
  line-height: 120px;

  img {
    width: 100%;
    vertical-align: middle;
  }
}

.con {
  text-align: left;

  > p {
    display: block;
    width: 100%;
  }

  ul {
    margin: 0 auto;

    li {
      width: 100px;
      display: inline-block;
      border-bottom: 1px solid #d9d9d9;
      border-right: 1px solid #d9d9d9;

      p {
        border: 1px solid #d9d9d9;
        border-bottom: 0;
        border-right: 0;
        text-align: center;
      }
    }
  }
}
.infoDialog{
  /deep/ .infoDiv{
    height:500px;
    overflow-y: auto;
    h1 {
      font-size: 22px !important;
      font-weight: bold !important;
      padding: 10px 0 !important;
      text-align: center;
    }
    > p {
      line-height: 30px;
    }

    h2 {
      font-size: 18px;
      line-height: 30px;
      margin-left: 40px;
      font-family: simsun, sans-serif;
      font-weight: bold;
    }
    
    h3 {
      font-size: 16px;
      line-height: 30px;
      font-family: simsun, sans-serif;
    }
    .con {
        h1 {
          text-align: left;
          font-size: 20px !important;
          display: inline;
          background: #000;
          color: #fff;
          padding: 0 !important;
          margin-left: 40px;
        }
      }

    > div {
      margin: 20px auto;
      font-size: 16px;
      border: 1px solid #000;
      padding: 10px;


      > p {
        text-align: center;
        color: #9c9c9c;
      }

      img {
        display: block;
        margin: 10px auto;
        width: 40%;
      }

      
    }
  }
}

/deep/ .contDiv,/deep/.contMDiv{
  width: 730px;
    height: calc(100% - 89px);
    float: left;
    padding: 40px 0px;
    -webkit-box-sizing: border-box;
    overflow: auto;
    overflow-y: scroll;
    margin-left: 50px;
    position: relative;
    margin-top: 5px;
}
/deep/.contMDiv{
  width: 730px;
  // width: 1050px;
}
.nextMoB{
  margin-left: 0 !important;
}
.nextB{
  margin-left: 45%;
    /* position: absolute; */
    /* text-align: center; */

}
.nextB button{
  font-size: 18px;
}
.conMainDiv{
  margin: 0 auto;
  border:1px solid #eee;
}
/deep/ .coverMobile .el-dialog__header {
}
/deep/ .coverMobile .el-dialog {
  padding: 20px;
  height:98% !important;
}
/deep/ .coverMobile .el-dialog__body{
  padding: 20px;
  width:100% !important;

}
/deep/ .contMoDiv,/deep/.conMoDiv{
  width: 100% !important;
  margin: 0px !important;
  padding: 0px !important;
}
</style>


// WEBPACK FOOTER //
// src/views/mobile/scorebook.vue